export const house = {
	className: 'icon-house',
	viewBox: '0 0 232.555 210.051',
	paths: ['M 232.555,114.784 116.277,0 0,114.784 l 10.336,10.47 18.604,-18.363 0,103.16 68.68,0 0,-79.986 37.322,0 0,79.986 68.68,0 0,-103.15 18.598,18.352 10.335,-10.469 z m -43.647,80.554 -39.254,0 0,-79.986 -66.748,0 0,79.986 -39.254,0 0,-102.965 72.625,-71.695 72.631,71.695 0,102.965 z']
}
